export const ticketType = {
    Standard: 'Standard',
    System: 'System'
};
